import FileSaver from "file-saver";
import { sanitizeDocumentUrl } from "Utils/utils";

/**
 * Download medication history export (PDF/xlsx). Uses blob save when possible so
 * exports work when async window.open is blocked by the browser.
 */
export async function downloadMedicationHistoryExport(downloadUrl, format, fileName) {
  const url = sanitizeDocumentUrl(String(downloadUrl || "").trim());
  if (!url) {
    return false;
  }

  const ext = format === "xlsx" ? "xlsx" : "pdf";
  const fallbackName = `medication-history.${ext}`;
  const resolvedName =
    (fileName && String(fileName).trim()) ||
    decodeURIComponent(url.split("/").pop()?.split("?")[0] || "") ||
    fallbackName;

  try {
    const response = await fetch(url);
    if (response.ok) {
      const blob = await response.blob();
      if (blob.size > 0) {
        FileSaver.saveAs(blob, resolvedName.includes(".") ? resolvedName : fallbackName);
        return true;
      }
    }
  } catch {
    // CORS or network — fall back to opening the URL
  }

  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  link.remove();
  return true;
}
